module.exports = __webpack_public_path__ + "img/vapp-logo-light_1.12716faa.svg";